'use strict';

/**
 * @classname FilterArea
 * @classdesc 絞り込みエリア開閉
 */
export default class FilterArea {
	/**
	 * @constructor
	 * @param {jQuery} $e - .btn--filter-area
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;this._$area = $('.area--filter');
		$e.on('click', () => this.onClick());
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof FilterArea
	 * @return undefined
	 */
	onClick() {
		if(this._$e.hasClass('open')) {
			this._$e.removeClass('open');
			this._$e.text('絞り込みを開く');
			this._$area.slideUp();

		} else {
			this._$e.addClass('open');
			this._$e.text('絞り込みを閉じる');
			this._$area.slideDown();
		}
	}
};
